import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, MessageSquare, Images, Newspaper, ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import { formatPrice } from "@/lib/settings";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ quotes: 0, messages: 0, projects: 0, posts: 0, quotes_total: 0 });
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [q, m, p, b] = await Promise.all([
          api.get("/quotes").then((r) => r.data),
          api.get("/contact").then((r) => r.data),
          api.get("/projects").then((r) => r.data),
          api.get("/blog").then((r) => r.data),
        ]);
        setStats({
          quotes: q.length,
          messages: m.filter((x) => !x.read).length,
          projects: p.length,
          posts: b.length,
          quotes_total: q.reduce((s, x) => s + (x.calc?.total || 0), 0),
        });
        setRecent(q.slice(0, 8));
      } catch {
        /* silent */
      }
    })();
  }, []);

  const cards = [
    { label: "Toplam Teklif", value: stats.quotes, icon: FileText, to: "/admin/quotes" },
    { label: "Yeni Mesaj", value: stats.messages, icon: MessageSquare, to: "/admin/messages" },
    { label: "Proje", value: stats.projects, icon: Images, to: "/admin/projects" },
    { label: "Blog Yazısı", value: stats.posts, icon: Newspaper, to: "/admin/blog" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <div className="text-xs font-bold uppercase tracking-widest text-brand-600 mb-2">Yönetim Paneli</div>
        <h1 className="font-display text-3xl md:text-4xl font-black text-ink-900">Hoş Geldiniz 👋</h1>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <Link to={c.to} key={c.label} className="rounded-2xl bg-white border border-ink-100 p-6 hover:brand-shadow transition-shadow">
            <div className="flex items-start justify-between">
              <div className="h-11 w-11 rounded-xl gradient-primary-soft grid place-items-center text-brand-600"><c.icon className="h-5 w-5" /></div>
              <ArrowUpRight className="h-4 w-4 text-ink-500" />
            </div>
            <div className="mt-6 font-display font-black text-4xl text-ink-900">{c.value}</div>
            <div className="text-sm text-ink-500 mt-1">{c.label}</div>
          </Link>
        ))}
      </div>

      <div className="mt-10 rounded-3xl bg-white border border-ink-100 overflow-hidden">
        <div className="p-6 border-b border-ink-100 flex items-center justify-between">
          <h3 className="font-display font-bold text-xl">Son Teklifler</h3>
          <div className="text-sm text-ink-500">Toplam tahmini: <b className="text-brand-600">{formatPrice(stats.quotes_total)}</b></div>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-ink-50">
              <tr>
                <th className="text-left px-4 py-3 font-semibold">No</th>
                <th className="text-left px-4 py-3 font-semibold">Ürün</th>
                <th className="text-left px-4 py-3 font-semibold">Ölçü</th>
                <th className="text-left px-4 py-3 font-semibold">Fiyat</th>
                <th className="text-left px-4 py-3 font-semibold">Durum</th>
                <th className="text-left px-4 py-3 font-semibold">Tarih</th>
              </tr>
            </thead>
            <tbody>
              {recent.map((q) => (
                <tr key={q.id} className="border-t border-ink-100 hover:bg-brand-50/30">
                  <td className="px-4 py-3 font-mono text-xs text-brand-600">{q.quote_no}</td>
                  <td className="px-4 py-3">{q.input?.furniture_type_name}</td>
                  <td className="px-4 py-3 text-ink-500">{q.input?.width_cm}×{q.input?.height_cm}×{q.input?.depth_cm}</td>
                  <td className="px-4 py-3 font-semibold text-ink-900">{formatPrice(q.calc?.total, q.currency)}</td>
                  <td className="px-4 py-3"><span className="rounded-full bg-brand-50 text-brand-700 px-2 py-0.5 text-[11px] font-bold">{q.status}</span></td>
                  <td className="px-4 py-3 text-ink-500">{new Date(q.created_at).toLocaleDateString("tr-TR")}</td>
                </tr>
              ))}
              {recent.length === 0 && (
                <tr><td colSpan={6} className="px-4 py-12 text-center text-ink-500">Henüz teklif yok.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
